<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="#1d1d1f" style="color: #fff" v-bind="attrs" v-on="on" small>
        Ver acciones
      </v-btn>
    </template>

    <v-list v-if="item" class="font-weight-bold">
      <!-- Pagar/Informar pago -->
      <v-list-item v-if="showPay">
        <v-list-item-title>
          <v-btn block color="success" rounded @click="handleAction('pending')">
            {{ isCustomer ? "Pagar" : "Informar pago" }}
          </v-btn>
        </v-list-item-title>
      </v-list-item>

      <v-list-item link v-if="showRequestFactoring">
        <v-list-item-title>
          <v-btn
            block
            style="background: #1d1d1f; color: #fff"
            rounded
            @click="handleAction('request_factoring')"
          >
            Solicitar factoraje
          </v-btn>
        </v-list-item-title>
      </v-list-item>

      <!-- Confirmar pago -->
      <v-list-item v-if="showConfirmPayment">
        <v-list-item-title>
          <v-btn color="success" rounded @click="handleAction('to_confirm')">
            Confirmar
          </v-btn>
        </v-list-item-title>
      </v-list-item>

      <!-- Rechazar pago -->
      <v-list-item v-if="showRejectPayment">
        <v-list-item-title>
          <v-btn color="error" rounded @click="handleAction('reject')">
            Rechazar
          </v-btn>
        </v-list-item-title>
      </v-list-item>

      <!-- Solicitar extensión de plazo -->
      <v-list-item
        link
        v-if="showRequestExtendTerm"
        @click="handleAction('request_extend_term')"
      >
        <v-list-item-title>Solicitar extensión de plazo</v-list-item-title>
      </v-list-item>

      <!-- Ver factura -->
      <v-list-item
        link
        v-if="item && item.invoice_url"
        @click="handleAction('show_invoice')"
      >
        <v-list-item-title>Ver factura</v-list-item-title>
      </v-list-item>

      <!-- Ver comprobante -->
      <v-list-item link v-if="showProofFile" @click="handleAction('show_file')">
        <v-list-item-title>Ver comprobante de pago</v-list-item-title>
      </v-list-item>

      <!-- Ver comprobante de compra -->
      <v-list-item link @click="handleAction('show_proof_purchase')">
        <v-list-item-title>Ver comprobante de compra</v-list-item-title>
      </v-list-item>

      <!-- Extender plazo -->
      <v-list-item
        link
        v-if="showExtendTerm"
        @click="handleAction('extend_term')"
      >
        <v-list-item-title>Extender plazo</v-list-item-title>
      </v-list-item>

      <!-- Adjuntar factura -->
      <v-list-item
        link
        v-if="showAttachInvoice"
        @click="handleAction('attach_invoice')"
      >
        <v-list-item-title>Adjuntar factura</v-list-item-title>
      </v-list-item>
      <!-- Editar -->
      <v-list-item link v-if="showEdit" @click="handleAction('edit_payment')">
        <v-list-item-title>Editar</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { ROLES, MAIN_ROLES } from "@/config/roles";
import { PAYMENT_STATUS_NAME_MAP } from "@/config/payment-states";
import { MANUAL_STATES } from "@/config/manual-payment-confirmation-states";

export default {
  props: ["item", "page", "index"],

  data() {
    return {};
  },

  methods: {
    async handleAction(code) {
      this.$emit("handleAction", this.item, code);
    },
  },

  computed: {
    // Helpers básicos
    userRole() {
      return this.$UserManager.getRole();
    },

    userMainRole() {
      return this.$UserManager.getMainRole();
    },

    isCustomer() {
      return this.userMainRole === MAIN_ROLES.CUSTOMER;
    },

    isSupplier() {
      return this.userMainRole === MAIN_ROLES.SUPPLIER;
    },

    isAdminSupplier() {
      return this.userRole === ROLES.ADMIN_SUPPLIER;
    },
    paymentStatus() {
      // Guard against undefined item (component renders before a payment is selected)
      if (!this.item) return null;
      return (
        this.item.status_id || this.item.status || this.item.payment_status
      );
    },

    // Estados según la matriz de reglas
    isPendingStatus() {
      return Number(this.paymentStatus) === PAYMENT_STATUS_NAME_MAP.pending;
    },

    isPaidStatus() {
      return [
        PAYMENT_STATUS_NAME_MAP.paid,
        PAYMENT_STATUS_NAME_MAP.paid_by_mangxo,
        PAYMENT_STATUS_NAME_MAP.paid_to_mangxo,
        PAYMENT_STATUS_NAME_MAP.payment_in_financing,
      ].includes(Number(this.paymentStatus));
    },

    isExpiredStatus() {
      return Number(this.paymentStatus) === PAYMENT_STATUS_NAME_MAP.expired;
    },

    isNonPaymentStatus() {
      return Number(this.paymentStatus) === PAYMENT_STATUS_NAME_MAP.non_payment;
    },

    isNotReportedStatus() {
      return (
        Number(this.paymentStatus) === PAYMENT_STATUS_NAME_MAP.not_reported
      );
    },

    isRejectedStatus() {
      return Number(this.paymentStatus) === PAYMENT_STATUS_NAME_MAP.rejected;
    },

    isManualPending() {
      // Guard against undefined item (same as paymentStatus)
      if (!this.item) return false;
      return this.item.manual_confirmation_status == MANUAL_STATES.pending;
    },
    // Botones de visibilidad según la matriz de reglas
    showPay() {
      // Customer: Pagar en estados Pendientes
      if (this.isCustomer) {
        return !this.isPaidStatus && !this.isManualPending;
      }
      // Supplier: Ya no puede informar pago, solo pagos via STP
      return false;
    },

    showConfirmPayment() {
      // Solo Supplier: Confirmar en estado A confirmar
      return this.isSupplier && this.isManualPending;
    },

    showRejectPayment() {
      // Solo Supplier: Rechazar en estado A confirmar
      return this.isSupplier && this.isManualPending;
    },

    showRequestExtendTerm() {
      // Solo Customer: Solicitar extensión en Pendientes (sin solicitud previa)
      return (
        this.isCustomer &&
        this.isPendingStatus &&
        !this.item?.pending_request_extend_term
      );
    },

    showProofFile() {
      // Ambos roles: Ver comprobante en Pagadas y A confirmar
      return (
        (this.isPaidStatus || this.isManualPending) &&
        this.item?.proof_payment_url
      );
    },

    showExtendTerm() {
      // Solo Supplier: Extender plazo en Pendientes
      return this.isSupplier && this.isPendingStatus && this.isAdminSupplier;
    },

    showAttachInvoice() {
      // Solo Supplier: Adjuntar factura en Pendientes cuando no hay factura
      return this.isSupplier && this.isPendingStatus && !this.item?.invoice_url;
    },
    showEdit() {
      // Supplier: Editar en Pendientes y Rechazadas
      return this.isSupplier && (this.isPendingStatus || this.isRejectedStatus);
    },
    showRequestFactoring() {
      return (
        this.isSupplier &&
        this.isPendingStatus &&
        this.$UserManager.canRequestFactoring()
      );
    },
  },
};
</script>
